import React, { useState } from "react";
import SelectInput from "../../FormItems/SelectInput.jsx";
import TextInput from "../../FormItems/TextInput.jsx";

// Step 1: Transactions details
// Props:
//  formData: object holding current form state
//  updateField: fn(name, value) updates parent form state
//  goNext: advances to next step (parent handles validation)
const Step1 = ({ formData, updateField, goNext, locations = [] }) => {
  const [errorMessages, setErrorMessages] = useState({});
  const validateForm = e => {
    if (e) e.preventDefault();
    // Basic required validation for step 1 only
    const errors = {};
    if (!formData.transactionType) {
      errors.transactionType = "Please select an item in the list.";
    }
    if (!formData.loanType) {
      errors.loanType = "Please select an item in the list.";
    }
    setErrorMessages(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }
    goNext();
  };

  return (
    <div className="form-order-services__step form-order-services__step--1">
      <h2 className="form-order-services__step-title txt-h4">
        Please provide details about the transaction
      </h2>
      <fieldset className="form-order-services__fieldset form-order-services__fieldset--inline-radios">
        <legend className="form-order-services__legend">
          Is this transaction regarding a property located in the United States?
        </legend>
        <div className="form-order-services__column-container">
          <div className="form-order-services__column">
            <label className="form-order-services__radio-option">
              <input
                type="radio"
                name="isInUS"
                value="Inside the U.S."
                checked={formData.isInUS === "Inside the U.S."}
                onChange={e => updateField("isInUS", e.target.value)}
              />
              <span>Inside the U.S.</span>
            </label>
          </div>
          <div className="form-order-services__column">
            <label className="form-order-services__radio-option">
              <input
                type="radio"
                name="isInUS"
                value="Outside the U.S."
                checked={formData.isInUS === "Outside the U.S."}
                onChange={e => updateField("isInUS", e.target.value)}
              />
              <span>Outside the U.S.</span>
            </label>
          </div>
        </div>
      </fieldset>

      {formData.isInUS === "Outside the U.S." ? (
        <div className="form-order-services__international-message">
          <p className="form-order-services__international-text">
            Please contact{" "}
            <a
              href="https://www.stewart.com/en/customer-type/international-title-services"
              target="_blank"
              rel="noopener noreferrer"
            >
              our international team
            </a>{" "}
            - they&apos;ll be happy to assist you!
          </p>
        </div>
      ) : (
        <>
          <div className="form-order-services__column-container">
            <div className="form-order-services__column">
              <SelectInput
                label="Transaction Type"
                name="transactionType"
                id="transactionType"
                required
                placeholder="Select Transaction Type"
                options={[
                  {
                    value: "All inclusive deed of trust",
                    text: "All inclusive deed of trust",
                  },
                  { value: "Cash", text: "Cash" },
                  { value: "Commercial", text: "Commercial" },
                  { value: "Contract of Sale", text: "Contract of Sale" },
                  { value: "Foreclosure", text: "Foreclosure" },
                  { value: "Leasehold", text: "Leasehold" },
                  { value: "New Construction", text: "New Construction" },
                  { value: "Owner Finance", text: "Owner Finance" },
                  {
                    value: "Real Estate Owned (REO)",
                    text: "Real Estate Owned (REO)",
                  },
                  { value: "Refinance", text: "Refinance" },
                  { value: "Relocation", text: "Relocation" },
                  { value: "Resale/Purchase", text: "Resale/Purchase" },
                ]}
                value={formData.transactionType}
                onChange={e => {
                  setErrorMessages(prev => ({ ...prev, transactionType: "" }));
                  updateField("transactionType", e.target.value);
                }}
                errorMsg={errorMessages.transactionType}
              />
            </div>
            <div className="form-order-services__column">
              <SelectInput
                label="Loan Type"
                name="loanType"
                required
                placeholder="Select Loan Type"
                options={[
                  { value: "Cash", text: "Cash" },
                  {
                    value: "Conventional Insured",
                    text: "Conventional Insured",
                  },
                  {
                    value: "Conventional Uninsured",
                    text: "Conventional Uninsured",
                  },
                  { value: "FHA", text: "FHA" },
                  { value: "FMHA", text: "FMHA" },
                  { value: "VA", text: "VA" },
                ]}
                value={formData.loanType}
                onChange={e => {
                  updateField("loanType", e.target.value);
                  setErrorMessages(prev => ({ ...prev, loanType: "" }));
                }}
                errorMsg={errorMessages.loanType}
              />
            </div>
          </div>
          <div className="form-order-services__column-container">
            <div className="form-order-services__column">
              <TextInput
                label="Sales Price (Optional)"
                name="salesPrice"
                type="number"
                placeholder="0"
                value={formData.salesPrice}
                extraClass="form-order-services__currency"
                onChange={e => {
                  updateField("salesPrice", e.target.value);
                }}
                helperText=""
              />
            </div>
            <div className="form-order-services__column">
              <TextInput
                label="Loan Amount (Optional)"
                name="loanAmount"
                type="number"
                step="0.01"
                placeholder="0"
                value={formData.loanAmount}
                extraClass="form-order-services__currency"
                onChange={e => {
                  updateField("loanAmount", e.target.value);
                }}
                helperText=""
              />
            </div>
          </div>
          <div className="form-order-services__column-container">
            <div className="form-order-services__column">
              <SelectInput
                label="Stewart Location"
                name="stewartLocation"
                placeholder="Select Office Location"
                options={locations.map(loc => ({
                  value: loc.Value,
                  text: loc.Label,
                }))}
                value={formData.stewartLocation}
                onChange={e => updateField("stewartLocation", e.target.value)}
                errorMsg=""
              />
            </div>
            <div className="form-order-services__column"></div> {/* spacer */}
          </div>
        </>
      )}

      {formData.isInUS !== "Outside the U.S." && (
        <div className="form-order-services__actions">
          <button
            className="btn btn--primary"
            onClick={validateForm}
          >
            NEXT
          </button>
        </div>
      )}
    </div>
  );
};

export default Step1;
